import "../src/dist/styles.css";
import "./App.css";
import About from "./Pages/About";
import Home from "./Pages/Home";
import Navbar from "../src/components/Navbar";
import { Route, Routes } from "react-router-dom";
import Models from "./Pages/Models";
import TestimonialsPage from "./Pages/TestimonialsPage";
import Team from "./Pages/Team";
import Contact from "./Pages/Contact";
import Service from "./Pages/Service";

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route index path='/' element={<Home />} />
        <Route path='about' element={<About />} />
        <Route path='services' element={<Service />} />
        <Route path='models' element={<Models />} />
        <Route path='testimonials' element={<TestimonialsPage />} />
        {/*  <Route path="team" element={<Team />} />*/}
        <Route path='contact' element={<Contact />} />
      </Routes>
    </>
  );
}

export default App;
